module.exports = __webpack_public_path__ + "media/emails/charge-35e8317e.png";